module.exports = __webpack_public_path__ + "static/girl_heart-1c4d312d79fdd01bea1c95fceb54dca9.png";